import { SelectionModel } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { IDroppedFile } from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';

@Injectable({ providedIn: 'root' })
export class FileSelectionsService {
	selections$ = new BehaviorSubject<string[]>([]);
	selections = new SelectionModel<Partial<IDroppedFile>>(true, []);
	selectionClear$ = new Subject<void>();

	clearSelections() {
		this.selections$.next([]);
		this.selections.clear();
		this.selectionClear$.next();
	}

	addToSelectionsList(fileId: string): void {
		this.selections$.pipe(take(1)).subscribe(selections => {
			if (!selections.includes(fileId)) {
				selections.push(fileId);
				this.selections$.next(selections);
			}
		});
	}

	removeFromSelectionsList(fileId: string): void {
		this.selections$.pipe(take(1)).subscribe(selections => {
			const index = selections.findIndex(pk => fileId === pk);
			selections.splice(index, 1);

			this.selections$.next(selections);
		});
	}

	removeManyFromSelectionsList(fileIds: string[]) {
		this.selections$.pipe(take(1)).subscribe(selections => {
			const newSelections = selections.filter(pk => !fileIds.includes(pk));

			this.selections$.next(newSelections);
		});
	}

	getSelections(): Promise<string[]> {
		return firstValueFrom(this.selections$);
	}

	removeSelections(ids: string[]) {
		ids.forEach(id => {
			const selectedFile = this.selections.selected.find(file => file.pk === id);
			if (selectedFile) {
				this.selections.toggle(selectedFile);
			}
		});
	}
}
